import { render, staticRenderFns } from "./ChamberAdd.vue?vue&type=template&id=7bebd05e&scoped=true&"
import script from "./ChamberAdd.vue?vue&type=script&lang=js&"
export * from "./ChamberAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bebd05e",
  null
  
)

export default component.exports